module.exports = __webpack_public_path__ + "img/Cover0.bcf83d1b.jpg";